import React, { useState, useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import FigmaDashBoard from './figmaImage/FigmaDashBoard.png';
import FigmaLoginPage from './figmaImage/FigmaLoginPage.png';
import FigmaAccountSetting from './figmaImage/FigmaAccountSetting.png';
import FigmaSecurity from './figmaImage/FigmaSecurity.png';
import FigmaSetTokenConfig from './figmaImage/FigmaSetTokenConfig.png';
import FigmaGenerateToken from './figmaImage/FigmaGenerateToken.png';
import FigmaGetImage from './FigmaGetImage';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import ParentContentCard from '../../common/ParentContentCard';
import {
  handleLinkSubmit,
  handleTokenSubmit,
  tokenSchema,
  linkSchema,
  checkTokenStatus,
  deleteFigmaTokenData,
} from './figma.util';
import CustomLoader from '../../common/CustomLoader';

export const FigmaToHtml = ({
  fetchFigmatoken,
  fetchFigmaData,
  projectId,
  version,
  fetchFigmaImage,
  projectDetail,
  iPlugins,
  deleteFigmaToHtmlData,
  deleteFigmaTokenDetails,
  fetchFigmaToHtmlData,
  generateFigmaToHtml,
  isReadOnly,
}) => {
  const [figmaLink, setFigmaLink] = useState(sessionStorage.getItem('figmaLink') || '');
  const [step, setStep] = useState(0);
  const [isExpired, setIsExpired] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const { aiModelConfigs } = projectDetail;
  const [figmaInstalled, setFigmaInstalled] = useState(false);
  const [figmaImageData, setFigmaImageData] = useState([]);
  const [loading, setLoading] = useState(false);

  const clearSessionStorage = () => {
    setFigmaLink('');
    sessionStorage.removeItem('figmaLink');
    sessionStorage.removeItem('figmaImageData');
  };

  useEffect(() => {
    if (!iPlugins || iPlugins.length === 0) return;
    const hasFigma = iPlugins.some((plugin) => plugin.code === 'FIGMA');

    if (hasFigma) {
      setFigmaInstalled(true);
    } else {
      setFigmaInstalled(false);
      deleteFigmaTokenData(projectId, version, deleteFigmaTokenDetails);
    }

    checkTokenStatus(
      setIsExpired,
      setFigmaImageData,
      clearSessionStorage,
      setFigmaLink,
      fetchFigmaData,
      projectId,
      version,
    );
  }, [fetchFigmaData, projectId, version, iPlugins]);

  const stepsData = [
    { text: 'Log in to your Figma account.', image: FigmaLoginPage },
    { text: 'Your DashBoard', image: FigmaDashBoard },
    { text: 'Go to your account settings.', image: FigmaAccountSetting },
    { text: 'Find the security section.', image: FigmaSecurity },
    { text: 'Click on Generate new token.', image: FigmaGenerateToken },
    { text: 'File scope is read only and copy the generated token', image: FigmaSetTokenConfig },
  ];

  const onTokenSubmit = (values) => {
    handleTokenSubmit({
      values,
      setFigmaLink,
      setLoading,
      setIsExpired,
      fetchFigmatoken,
      projectId,
      version,
      clearSessionStorage,
    });
  };

  const onLinkSubmit = (values) => {
    handleLinkSubmit({
      values,
      setLoading,
      setFigmaLink,
      setFigmaImageData,
      projectId,
      version,
      setIsExpired,
      fetchFigmaImage,
      clearSessionStorage,
    });
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const currentStep = step < stepsData.length ? stepsData[step] : stepsData[stepsData.length - 1];

  return (
    <ParentContentCard title={'Figma To Html'} icon={'section'}>
      {figmaInstalled ? (
        <div className="container-fluid">
          <div className="row">
            {isExpired ? (
              <>
                <div className="col-md-6">
                  <h3>Generate Figma Access Token Steps:</h3>
                  <p>{currentStep.text}</p>
                  <img
                    src={currentStep.image}
                    alt={currentStep.text}
                    className="img-fluid border mb-3"
                    style={{ cursor: 'pointer', maxHeight: '300px' }}
                    onClick={openModal}
                  />
                  <h5>Click photo to Zoom In</h5>
                  <div className="d-flex justify-content-between mt-3">
                    <button
                      className="btn btn-secondary"
                      onClick={() => setStep((prev) => Math.max(prev - 1, 0))}
                      disabled={step === 0}
                    >
                      Previous
                    </button>
                    {step < stepsData.length ? (
                      <button
                        className="btn btn-primary"
                        onClick={() => setStep((prev) => prev + 1)}
                      >
                        {step === stepsData.length - 1 ? 'Finish' : 'Next'}
                      </button>
                    ) : (
                      <button className="btn btn-primary" onClick={() => setStep(0)}>
                        Restart
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <h3>Enter Your Token</h3>
                  <Formik
                    initialValues={{ token: '' }}
                    validationSchema={tokenSchema}
                    onSubmit={isReadOnly ? undefined : onTokenSubmit}
                  >
                    {({ values }) => (
                      <Form>
                        <div className="mb-3">
                          <Field
                            id="token"
                            name="token"
                            type="text"
                            className="form-control p-3"
                            placeholder="Enter your Figma access token"
                          />
                          <ErrorMessage name="token" component="div" className="text-danger" />
                        </div>
                        <div className="d-flex justify-content-end mt-3">
                          <button
                            type="submit"
                            className={`btn ${
                              values.token ? 'btn-theme-submit' : 'btn-disabled'
                            } btn-md`}
                            disabled={loading || !values.token || isReadOnly}
                            title={isReadOnly ? 'Read-Only Mode' : 'Submit'}
                          >
                            <i className={`wb ${drapcodeIcon('submit')}`}></i>
                            &nbsp;Submit
                            <CustomLoader loading={loading}></CustomLoader>
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </>
            ) : (
              <div className="col-md-12">
                <h3>Enter Figma Link</h3>
                <Formik
                  initialValues={{ figmaLink }}
                  validationSchema={linkSchema}
                  onSubmit={isReadOnly ? undefined : onLinkSubmit}
                >
                  {({ values }) => (
                    <Form>
                      <div className="mb-3">
                        <Field
                          id="figmaLink"
                          name="figmaLink"
                          type="url"
                          className="form-control p-3"
                          placeholder="Enter your Figma link"
                        />
                        <ErrorMessage name="figmaLink" component="div" className="text-danger" />
                      </div>
                      <div className="d-flex justify-content-end mt-3">
                        <button
                          type="submit"
                          className={`btn ${
                            values.figmaLink ? 'btn-theme-submit' : 'btn-theme-disabled'
                          } btn-md`}
                          disabled={loading || !values.figmaLink || isReadOnly}
                          title={isReadOnly ? 'Read-Only Mode' : 'Submit'}
                        >
                          <i className={`wb ${drapcodeIcon('submit')}`}></i>
                          &nbsp;Submit
                          <CustomLoader loading={loading}></CustomLoader>
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )}
          </div>
          {!isExpired && (
            <div className="row">
              <div className="col-md-12">
                <FigmaGetImage
                  version={version}
                  projectId={projectId}
                  setFigmaImageData={setFigmaImageData}
                  figmaLink={figmaLink}
                  aiModelConfigs={aiModelConfigs}
                  figmaImageData={figmaImageData}
                  deleteFigmaToHtmlData={deleteFigmaToHtmlData}
                  fetchFigmaToHtmlData={fetchFigmaToHtmlData}
                  generateFigmaToHtml={generateFigmaToHtml}
                  isReadOnly={isReadOnly}
                />
              </div>
            </div>
          )}

          {showModal && (
            <div className="modal fade show d-block" tabIndex="-1" onClick={closeModal}>
              <div
                className="modal-dialog modal-lg mt-5 modal-dialog-centered"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="modal-content">
                  <div className="modal-body text-center">
                    <img
                      src={currentStep.image}
                      alt={currentStep.text}
                      className="w-100 mw-100"
                      style={{ maxHeight: '90vh' }}
                    />
                  </div>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={closeModal}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className="d-flex justify-content-start align-items-center p-2 alert"
          role="alert"
          id="alertWarning"
          style={{
            color: '#856404',
            backgroundColor: '#fff3cd',
            borderColor: '#ffeeba',
          }}
        >
          <h5>
            <i className="fas fa-exclamation-triangle mx-2" aria-hidden="true"></i>
            Please Install Figma To Html Plugin
          </h5>
        </div>
      )}
    </ParentContentCard>
  );
};

export default FigmaToHtml;
